import styled from '@mui/material/styles/styled';
import {Link, Stack, Typography} from '@mui/material';

const ModalContent = styled('div')`
	display: flex;
	flex-direction: column;
	color: ${({theme}) => theme.palette.text.primary};
	justify-content: center;
`;

const StyledLink = styled(Link)`
	font-size: 12px;
	cursor: pointer;
`;

const StyledHeader = styled(Stack)`
	flex-direction: row;
	align-items: center;
	gap: 8px;
	min-height: 73px;
	background-color: ${({theme}) => theme.palette.primary.main};
	padding: 16px;

	${({theme}) => theme.breakpoints.up('sm')} {
		padding: 24px;
		min-height: 97px;
	}
`;

const StyledHeaderTitle = styled(Typography)`
	font-size: 1.25rem;
	font-weight: 600;
	color: ${({theme}) => theme.palette.common.white};
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
`;

const StyledCard = styled(Stack)`
	background-color: ${({theme}) => theme.palette.common.white};
	border-radius: 8px;
	padding: 32px;
`;

const StyledCardContainer = styled(Stack)`
	padding: 16px;
	background-color: ${({theme}) => theme.colors.gray['20Percent']};

	${({theme}) => theme.breakpoints.up('sm')} {
		padding: 24px 32px;
	}
`;

export {ModalContent, StyledLink, StyledHeader, StyledHeaderTitle, StyledCard, StyledCardContainer};
